import config from '@/api/config';
import _ from 'lodash';

const state = () => ({
	candidates: [],
	matched: [],
	loaded: false,
	includeArchived: false,
	matchedSearch: null,
	unmatchedSearch: null
});

const getters = {
	getCandidates: (state) => {
		if(state.unmatchedSearch)
		{
			return _.filter(state.candidates, (candidate)=>{
				//match on any field in candidate.properties {"name": "anthony", "lastName": "smith"}
				const properties = candidate.properties;
				const search = state.unmatchedSearch.toLowerCase();

				const found = _.find(properties, (value) => {
  					return deepIncludes(value, search);
				});
				return found;
			});
		}
		return state.candidates;
	},

	getMatched: (state) => {
		if(state.matchedSearch)
		{
			return _.filter(state.matched, (matched)=>{
				//match on any field in candidate.properties {"name": "anthony", "lastName": "smith"}
				const properties = matched.properties;
				const search = state.matchedSearch.toLowerCase();
				const found = _.find(properties, (value) => {
  					return deepIncludes(value, search);
				});
				return found;
			});
		}
		return state.matched;
	}
};


const mutations = {
	setCandidates: (state, candidates) => {
		state.candidates = candidates;
	},
	setMatched: (state, matched) => {
		state.matched = matched;
	},
	setLoaded: (state, loaded) => {
		state.loaded = loaded;
	},
	setIncludeArchived: (state, value) => {
		state.includeArchived = value;
	},
	setSearch: (state, search) => {
		state.search = search;
	},
	setMatchedSearch: (state, search) => {
		state.matchedSearch = search;
	},
	setUnmatchedSearch: (state, search) => {
		state.unmatchedSearch = search;
	}
};

const actions = {
	load: async ({commit, state}, { integrationId, type, otherSource = null}) => {
		
		commit('setLoaded', false);
		
		const { includeArchived } = state;
		const candidates = await config.getCandidates(integrationId, type, includeArchived, otherSource);
		const matched = await config.getMatched(integrationId, type);
		const suggested = await config.getSuggested(integrationId, type, otherSource);

		_.each(suggested, (suggestion)=>{
			const candidate = _.find(candidates, ['externalKey', suggestion.candidate.externalKey]);
			if(candidate)
			{
				candidate.suggested = suggestion;
			}
		});
		
		commit('setCandidates', candidates);
		commit('setMatched', matched);
		commit('setLoaded', true);

	},

	async matchCandidate({dispatch}, { integrationId, externalKey, entityId, type })
	{
		await config.matchCandidate(integrationId, externalKey, entityId);
		await dispatch('entities/load', { type, fresh: true }, {root:true});
		await dispatch('load', { integrationId, type });
	},

	async unlinkCandidate({dispatch}, { integrationId, entityId, type })
	{
		await config.unlinkCandidate(integrationId, entityId);
		await dispatch('entities/load', { type, fresh: true }, {root:true});
		await dispatch('load', { integrationId, type });
		
	},

	async setIncludeArchived({commit, dispatch}, { integrationId, type, value})
	{
		commit('setIncludeArchived', value);
		await dispatch('load', { integrationId, type });
	},

	async setMatchedSearch({commit, dispatch}, search)
	{
		commit('setMatchedSearch', search);
	},

	async setUnmatchedSearch({commit, dispatch}, search)
	{
		commit('setUnmatchedSearch', search);
	}

};

function deepIncludes(value, search) {
  if (!value) return false;

  // Normalize search once
  const normalizedSearch = search.toLowerCase();

  if (typeof value === 'string') {
    return value.toLowerCase().includes(normalizedSearch);
  }

  if (Array.isArray(value)) {
    return value.some(v => deepIncludes(v, normalizedSearch));
  }

  if (typeof value === 'object') {
    return Object.values(value).some(v => deepIncludes(v, normalizedSearch));
  }

  return false;
}

export default {
	namespaced: true,	
	state,
	getters,
	mutations,
	actions
};
